import React, { useEffect } from 'react';
import {
	Col,
	Form,
	Offcanvas,
	OffcanvasBody,
	OffcanvasHeader,
	Row,
	Spinner,
} from 'reactstrap';
import SimpleBar from 'simplebar-react';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import 'dayjs/locale/es-mx';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import * as Yup from 'yup';
import { useFormik } from 'formik';

dayjs.extend(utc);

const SummaryOffcanvasContainer = ({ isOpen, toggle, filters = {}, onSubmit }) => {
	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			date_range: filters.date_range || [],
		},
		validationSchema: Yup.object({
			date_range: Yup.array(),
		}),
		onSubmit: values => {
			const dateRange = values.date_range?.filter(Boolean) ?? [];
			onSubmit({ date_range: dateRange.length === 2 ? dateRange : [] });
			toggle();
		},
	});

	useEffect(() => {
		if (isOpen) {
			validation.setFieldValue('date_range', filters.date_range || []);
		}
	}, [isOpen]);

	const handleClearFilters = () => {
		validation.setFieldValue('date_range', []);
		onSubmit({ date_range: [] });
		toggle();
	};

	return (
		<Offcanvas
			isOpen={isOpen}
			direction="end"
			toggle={toggle}
			className="border-bottom"
		>
			<OffcanvasHeader toggle={toggle}>Filtros</OffcanvasHeader>
			<OffcanvasBody className="p-3">
				<SimpleBar style={{ height: '100vh' }}>
					<Form onSubmit={validation.handleSubmit}>
						<Row className="g-3">
							<Col sm={12}>
								<DatesProvider
									settings={{
										locale: 'es-mx',
										firstDayOfWeek: 1,
										weekendDays: [0],
										timezone: 'UTC',
									}}
								>
									<DatePickerInput
										key="date_range"
										type="range"
										label="Rango de fecha"
										id="date_range"
										name="date_range"
										placeholder="Seleccione un rango"
										value={validation.values.date_range}
										onChange={date => {
											const dates = date.filter(item => item != null);
											validation.setFieldValue(
												'date_range',
												dates.length ? dates : []
											);
										}}
										onBlur={validation.handleBlur}
										valueFormat="DD-MM-YYYY"
										clearable
									/>
								</DatesProvider>
							</Col>
						</Row>

						<Row>
							<Col>
								<div className="hstack gap-2 mt-4">
									<button
										type="button"
										className="btn btn-label btn-danger"
										onClick={handleClearFilters}
									>
										<i className="ri-filter-off-fill label-icon"></i> Limpiar
									</button>
									<button
										type="submit"
										className="btn btn-label btn-primary"
										id="add-btn"
									>
										<i className="ri-filter-fill label-icon"></i> Filtrar
									</button>
								</div>
							</Col>
						</Row>
					</Form>
				</SimpleBar>
			</OffcanvasBody>
		</Offcanvas>
	);
};

export default SummaryOffcanvasContainer;
